import api from "../../Api/feathers-client";
import { convertMinToSecond } from "../../Js/TimeAndDate";

// Call backend service to get all tasks
export const getTaskList = async (
  loggedInUser,
  site_uuid,
  skip,
  limit,
  query = {}
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("tasks").find({
        query: {
          ...query,
          created_by: loggedInUser,
          site_uuid: site_uuid,
          is_deleted: false,
          $sort: {
            created_at: -1,
          },
          $skip: skip,
          $limit: limit,
        },
      });

      resolve({
        status: 200,
        message: "All Task",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get all attempted
export const getAttemptedUniq = async (site_uuid, user_id) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find({
        query: {
          $select: ["target"],
          actor: user_id,
          site_uuid: site_uuid,
          verb: "ratingAssignment",
          $group: ["target"],
          $limit: -1
        },
      });

      resolve({
        status: 200,
        message: "All Assignments",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
